<template>
    <div id="ReceiveAtElevator">
        <h1>Receive at the Elevator</h1>
    </div>
</template>

<script>
  export default {
    name: 'ReceiveAtElevator'
  }
</script>
